module.exports = __webpack_public_path__ + "img/instagram-icon.1447d730.svg";